module.exports = __webpack_public_path__ + "static/media/01-2.38dbffeb.webp";